const serviceTerms = [
    { 
        id: "overview", 
        title: "1. Overview", 
        content: "Welcome to our AI & IT StartUp Agency! By using our services, you agree to comply with these terms and conditions, ensuring seamless and ethical collaboration in the tech industry."
    },
    { 
        id: "acceptable-use", 
        title: "2. Acceptable Use", 
        content: "Our platform and services are intended for lawful, professional use. Engaging in illegal activities, misuse of AI tools, or exploiting system vulnerabilities is strictly prohibited."
    },
    { 
        id: "subscription", 
        title: "3. Subscription Terms", 
        content: "Our AI & IT solutions are available through subscription models. Payments must be made based on the chosen plan, and non-payment may lead to restrictions or suspension of services."
    },
    { 
        id: "user-obligations", 
        title: "4. User Obligations", 
        content: "Users are responsible for the security of their accounts. Any unauthorized access or suspicious activity must be reported immediately to ensure the safety of our platform."
    },
    { 
        id: "limitation-liability", 
        title: "5. Limitation of Liability", 
        content: "Our agency is not responsible for indirect, consequential, or incidental damages that may arise from using or failing to access our services, except as allowed by applicable law."
    },
    { 
        id: "termination", 
        title: "6. Termination", 
        content: "We reserve the right to terminate access to our platform if users violate these terms, or at our discretion, with proper notice when applicable."
    },
    { 
        id: "intellectual-property", 
        title: "7. Intellectual Property", 
        content: "All intellectual property related to our platform and technology belongs to our AI & IT StartUp Agency. Users are granted a non-exclusive license to use our services under these terms."
    },
    { 
        id: "governing-law", 
        title: "8. Governing Law", 
        content: "These terms are governed by the laws of [Your Jurisdiction]. Any legal disputes will be resolved in the courts of [City/Region]."
    },
    { 
        id: "contact-info", 
        title: "9. Contact Information", 
        content: "If you have any questions or need support, please contact us at support@[agencyname].com or call +[Phone Number]."
    }
];

export default serviceTerms;